import { createStorageValue } from '@interhyp/platform-storage';
import { z } from 'zod';
import { portalNamespace } from '../namespaces';
export const consentValue = createStorageValue({
    namespace: portalNamespace,
    schema: z.record(z.record(z.boolean())),
    type: 'local',
    id: Symbol('consent'),
});
